import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import MockTestTable from './MockTestTable';

const MockTest = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Mock Test' parent='Mock Test' />
      <Container fluid={true}>
        <Row>
          <MockTestTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default MockTest;
